import { Stack, Alert } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconInfoCircle } from '@tabler/icons-react';
import { WebBotProviderData, useGetApiBotProviderAssetBundleListBundles } from '@/API';
import { AssetBundleManager } from './AssetBundleManager';
import { ExtensionList } from './ExtensionList';

interface WebBotExtensionEditProps {
  workspaceId?: string;
  botProviderId?: string;
  form: UseFormReturnType<WebBotProviderData>;
}

export function WebBotExtensionEdit({
  workspaceId,
  botProviderId,
  form,
}: WebBotExtensionEditProps) {
  const bundlesQuery = useGetApiBotProviderAssetBundleListBundles({
    workspaceId: workspaceId || '',
    botProviderId: botProviderId || '',
  });

  const bundleNames = (bundlesQuery.data?.data || [])
    .map((b) => b.bundleName)
    .filter((n): n is string => !!n);

  const handleBundleRenamed = (oldName: string, newName: string) => {
    const currentExtensions = form.values.extensions || [];
    const updatedExtensions = currentExtensions.map((ext) => {
      if (ext.bundlePath === oldName) {
        return { ...ext, bundlePath: newName };
      }
      if (ext.bundlePath && ext.bundlePath.startsWith(`${oldName}/`)) {
        return { ...ext, bundlePath: `${newName}${ext.bundlePath.slice(oldName.length)}` };
      }
      return ext;
    });
    form.setFieldValue('extensions', updatedExtensions);
  };

  if (!workspaceId || !botProviderId) {
    return (
      <Alert icon={<IconInfoCircle size={16} />} title="提示" color="blue">
        請先建立或儲存 BotProvider 後，即可在此上傳資產包與設定 Extension 擴充掛載區域。
      </Alert>
    );
  }

  return (
    <Stack gap="lg">
      <AssetBundleManager
        workspaceId={workspaceId}
        botProviderId={botProviderId}
        extensions={form.values.extensions || []}
        onBundleRenamed={handleBundleRenamed}
      />

      <ExtensionList
        form={form}
        availableBundles={bundleNames}
      />
    </Stack>
  );
}
